import { render, staticRenderFns } from "./page-loading.vue?vue&type=template&id=8fc19912&"
import script from "./page-loading.vue?vue&type=script&lang=js&"
export * from "./page-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports